<div class="event__search__floater">
  <div class="search__anchor">
          <input type="text"
                 [(ngModel)]="search"
                 autocomplete="off"
                 class="search__bar"
                 placeholder="Search...">
      <input class="search__submit" type="submit">
      <div class="search__toggler"></div>
  </div>
</div>
